export default __webpack_public_path__ + "static/live-like-a-local-2-4a60bcc66568913f3e6f0bcd081cf20e.png";